<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <job-exit-cause-create-or-update v-model="cause" :errors="errors"></job-exit-cause-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="job-exit-cause"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import JobExitCauseCreateOrUpdate from './components/JobExitCauseCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        JobExitCauseCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Sebep",key:"Name", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            cause:{
                Id:null,
                Name:null,
                Code:null,
                SGKParameterIds:[]
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.cause.Id = null
            this.cause.Name = null
            this.cause.Code = null
            this.cause.SGKParameterIds = []
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.JobExitCause.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.cause.Id = item.Id
            this.cause.Name = item.Name
            this.cause.Code = item.Code
            this.cause.SGKParameterIds = item.SGKParameterIds || []
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.JobExitCause.CreateOrUpdate(this.editing,this.cause).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} işten çıkış sebebini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.JobExitCause.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>